import axios from 'axios'
import {auth} from "../firebase/firebaseConfig";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
})

// "Remember this device": the server accepts this token in place of the texted code.
export const TRUSTED_DEVICE_KEY = '2FA_TRUSTED_DEVICE@ZonaAdmin';
let redirectingToCode = false;
api.interceptors.request.use((config) => {
    try {
        const trusted = JSON.parse(localStorage.getItem(TRUSTED_DEVICE_KEY) || 'null');
        if (trusted && typeof trusted.token === 'string' && trusted.uid === auth.currentUser?.uid && trusted.expires > Date.now()) {
            config.headers['X-Admin-Device'] = trusted.token;
        }
    } catch (e) {
        // Malformed value: send nothing; the server asks for the code.
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const currentUser = auth.currentUser;

                if (currentUser) {
                    const newToken = await currentUser.getIdToken(true);
                    api.defaults.headers.Authorization = `Bearer ${newToken}`;
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;

                    return api(originalRequest);
                } else {
                    console.warn("No current user found for token refresh.");
                }
            } catch (refreshError) {
                console.error("Token refresh failed:", refreshError);
                await auth.signOut();
                window.location.href = "/signin";
            }
        }

        // The server wants the texted code for this sign-in: back to the code screen, once,
        // and have that screen send a fresh code. A remembered device the server refused is dropped.
        if (error.response?.status === 403 && error.response?.data?.code === 'admin_2fa_required'
            && window.location.pathname !== '/two-factor-auth') {
            if (!redirectingToCode) {
                redirectingToCode = true;
                localStorage.removeItem(TRUSTED_DEVICE_KEY);
                localStorage.setItem('2FA@ZonaAdmin', JSON.stringify({
                    type: '2FA', verified: false, sendCode: true, expires: Date.now() + 15 * 60 * 1000,
                }));
                window.location.href = '/two-factor-auth';
            }
            return new Promise(() => {}); // the page is leaving; don't show errors meanwhile
        }

        return Promise.reject(error);
    }
);


export default api